import type { HttpClient } from '../../../types/api';
import type { PostContactNoLoginFormData, PostContactNoLoginResponse } from '../types';

export const postContactNoLogin = async (
  formData: PostContactNoLoginFormData,
  httpClient: HttpClient,
): Promise<PostContactNoLoginResponse> => {
  return await httpClient.post<PostContactNoLoginResponse>('/user/v1/contact/no-login', {
    body: formData,
    headers: {},
  });
};
